const _excluded = ["isLoading", "error", "helperText", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { TextField } from 'seagull';
import styles from "./OTPField.module.scss";
export default function OTPField(_ref) {
  let {
      isLoading,
      error,
      helperText,
      onChange: _onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [otp, setOtp] = useState('');
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    className: styles.otpInput,
    type: "text",
    inputMode: "numeric",
    autoComplete: "one-time-code",
    label: "6\u2013digit code",
    placeholder: "",
    value: otp,
    "data-testid": "otp-input",
    inputProps: {
      maxLength: 6
    },
    onChange: async e => {
      const sanitizedOTPValue = e.target.value.slice(0, 6).replace(/\D/g, '');
      setOtp(sanitizedOTPValue);
      _onChange(sanitizedOTPValue, sanitizedOTPValue.length === 6);
    },
    error: error,
    helperText: helperText,
    disabled: isLoading
  }));
}